import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { RootState } from "../../../../redux/store";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../redux/loader/loaderActions";
import baseUrl from "../../../../api/baseUrl";
import FormDate from "../../../../components/formFeild/FormDate";
import FormCheck from "../../../../components/formFeild/FormCheck";
import BottomTab from "../../../../components/pagination/BottomTab";
import AllPaymentReport from "../payments/allpayments/AllPaymentReport";
import CommonLayout from "../../../../layouts/commonLayout/CommonLayout";
import Container from "../../../../layouts/containers/Container";
import PaymentCount from "./PaymentCount";
interface FormData {
  payments: boolean;
  startDate: string;
  endDate: string;
}
function AllPaymentList() {
  const navigate = useNavigate();
  const [report, setreport] = useState(false);
  const [openpayments, setopenpayments] = useState(false);
  const [payment, setpayment] = useState([]);
  const [count, setCount] = useState(0);
  const [allcount, setallCount] = useState({});
  const [page, setPage] = useState(1);
  const search = useSelector((state: RootState) => state.searching.patientData);
  const methods = useForm<FormData>();
  const { watch, handleSubmit, reset } = methods;
  const dispatch = useDispatch();
  const getData = useCallback(
    (
      searchTerm: string,
      pageNum?: number,
      startDate?: string,
      endDate?: string
    ) => {
      dispatch(setloadeActive());

      baseUrl
        .get("payment/getAllPaymentCount", {
          headers: {},
          params: {
            startDate: startDate,
            endDate: endDate,
          },
        })
        .then((response) => {
          dispatch(setloadeDeactive());
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
        });
      baseUrl
        .get("payment/getAllPayment-list", {
          headers: {
            keyword: searchTerm,
            page: pageNum,
          },
          params: {
            startDate: startDate,
            endDate: endDate,
          },
        })
        .then((response) => {
          dispatch(setloadeDeactive());

          setallCount(response.data.allcount);
          setpayment(response.data.data);

          setCount(response.data.count);
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
        });
    },
    [dispatch]
  );
  useEffect(() => {
    getData(search, page);
  }, [search, page, getData]);
  useEffect(() => {
    const { unsubscribe } = watch((value) => {
      if (value.startDate && value.endDate)
        getData("", page, value.startDate, value.endDate);
      if (value.payments) {
        setopenpayments(true);
      } else {
        setopenpayments(false);
      }
    });
    return () => unsubscribe();
  }, [watch]);
  const onPageChange = useCallback(
    (newPage: number) => {
      setPage(newPage);
      getData(search, newPage);
    },
    [getData, search]
  );
  const closeModal = useCallback(() => {
    setreport(false);
  }, []);
  const onSubmit: SubmitHandler<FormData> = useCallback(
    async (data) => {
      try {
        const response = await baseUrl.get("client/payment/payment-report", {
          responseType: "blob",
          params: {
            startDate: data.startDate,
            endDate: data.endDate,
            payments: data.payments,
          },
        });

        if (response.status === 204) {
          toast("No data found");
          return;
        }
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(pdfBlob);
        link.download = "downloaded.pdf";
        document.body.appendChild(link);

        link.click();

        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },
    [closeModal]
  );
  const methodReset = useCallback((e: any) => {
    e.preventDefault();
    reset();
    getData(search, page);
  }, []);
  return (
    <CommonLayout>
      <div className="mt-6 space-y-3">
        <PaymentCount count={allcount} />

        <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 p-4">
          {/* Filter Form */}
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} className="flex flex-wrap items-end gap-3 mb-3">
              <div className="flex gap-3">
                <FormDate label="From" name="startDate" />
                <FormDate label="To" name="endDate" />
              </div>
              <div className="flex gap-2">
                <button
                  type="submit"
                  className="px-4 py-2.5 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all text-xs"
                >
                  Download PDF
                </button>
                <button
                  onClick={methodReset}
                  className="px-4 py-2.5 rounded-lg border border-slate-200 text-slate-600 font-medium hover:bg-slate-50 transition-colors text-xs"
                >
                  Reset
                </button>
              </div>
            </form>
          </FormProvider>

          {/* Desktop Table */}
          <div className="hidden md:block overflow-hidden rounded-lg border border-slate-200">
            <table className="w-full">
              <thead className="bg-slate-50 border-b border-slate-100">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Invoice No</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Date</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Patient</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Dentist</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Total</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Paid</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Discount</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Method</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 uppercase">Due/Adv</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {payment.map((item: any, index) => (
                  <tr
                    key={index}
                    onClick={() => navigate(`/client/payments/invoice/${item?.treatmentId}`)}
                    className="hover:bg-slate-50 cursor-pointer transition-colors"
                  >
                    <td className="px-3 py-2 text-xs font-medium text-indigo-600">{item?.invoiceNo}</td>
                    <td className="px-3 py-2 text-xs text-slate-600">{item?.updatedAt?.split("T")[0]}</td>
                    <td className="px-3 py-2 text-xs font-medium text-slate-800">{item?.patientName}</td>
                    <td className="px-3 py-2 text-xs text-slate-600">{item?.doctorName}</td>
                    <td className="px-3 py-2 text-xs text-slate-600">{item?.payable}</td>
                    <td className="px-3 py-2 text-xs font-semibold text-emerald-600">
                      {item?.cash + item?.card + item?.bankTransfer}
                    </td>
                    <td className="px-3 py-2 text-xs text-orange-600">{item?.discount}</td>
                    <td className="px-3 py-2">
                      <span className="px-2 py-0.5 bg-slate-100 text-slate-600 rounded-md text-xs font-medium">
                        {paymentMethod(item?.card, item?.cash, item?.bankTransfer)}
                      </span>
                    </td>
                    <td className={`px-3 py-2 text-xs font-semibold ${item?.due > 0 ? "text-red-600" : "text-emerald-600"}`}>
                      {item?.due}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-2">
            {payment.map((item: any, index) => (
              <div
                key={index}
                onClick={() => navigate(`/client/payments/invoice/${item?.treatmentId}`)}
                className="bg-slate-50 rounded-lg p-3 cursor-pointer hover:bg-slate-100 transition-colors"
              >
                <div className="flex items-center justify-between mb-1.5">
                  <span className="font-medium text-xs text-indigo-600">{item?.invoiceNo}</span>
                  <span className="text-[10px] text-slate-500">{item?.updatedAt?.split("T")[0]}</span>
                </div>
                <h3 className="font-semibold text-xs text-slate-800 mb-1.5">{item?.patientName}</h3>
                <div className="grid grid-cols-3 gap-1.5 text-xs">
                  <div className="bg-white rounded-md p-1.5 text-center">
                    <p className="text-[10px] text-slate-500">Total</p>
                    <p className="font-semibold text-slate-700">{item?.payable}</p>
                  </div>
                  <div className="bg-emerald-50 rounded-md p-1.5 text-center">
                    <p className="text-[10px] text-emerald-600">Paid</p>
                    <p className="font-semibold text-emerald-700">{item?.cash + item?.card + item?.bankTransfer}</p>
                  </div>
                  <div className={`rounded-md p-1.5 text-center ${item?.due > 0 ? "bg-red-50" : "bg-emerald-50"}`}>
                    <p className={`text-[10px] ${item?.due > 0 ? "text-red-600" : "text-emerald-600"}`}>
                      {item?.due > 0 ? "Due" : "Adv"}
                    </p>
                    <p className={`font-semibold ${item?.due > 0 ? "text-red-700" : "text-emerald-700"}`}>{item?.due}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <BottomTab title="Patient" count={count} onPageChange={onPageChange} />
          {report && <AllPaymentReport closeModal={closeModal} />}
        </div>
      </div>
    </CommonLayout>
  );
}

export default AllPaymentList;
function paymentMethod(card: number, cash: number, bank: number) {
  const methods = [];
  if (card > 0) methods.push("card");
  if (cash > 0) methods.push("cash");
  if (bank > 0) methods.push("bank");

  return methods.length > 0 ? methods.join("/") : "none";
}
